import { Component, Input } from '@angular/core';

@Component({
  selector: 'gameday-direct-header', //tslint:disable-line:component-selector component-selector-name -- for semantic markup
  templateUrl: './header.component.html',
  styleUrls: ['./header.styles.scss']
})
export class HeaderComponent {
  @Input()
  public loggedIn;

  @Input()
  public username;
}
